import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeading',
  props: {
    heading: null
  },
  setup(__props: any) {

const props = __props as {
  heading: string;
};



const { heading } = toRefs(props);

return { __sfc: true,props, heading }
}

})